<template>
    <v-card>
        <v-card-title>Geo Map View Management</v-card-title>

        <v-divider></v-divider>

        <v-card-text style="max-height: calc(75vh - 0px); overflow-y: scroll;">

            <v-col cols="12">

                <span class="config-table-label">View Libray</span>
                <v-simple-table class="config-table" height="calc(75vh - (50px + 375px))" style="min-height: 100%;" fixed-header>
                    <thead>
                        <tr>
                            <th class="text-left">Name</th>
                            <th class="text-left">Owner</th>
                            <th class="text-left">Device Type</th>
                            <th class="text-left">Private/Public</th>
                            <th class="text-left">Favorite</th>
                            <th class="text-left">Default</th>
                            <th class="text-center"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <tr style="cursor: pointer" v-for="view in $props.mapViews" :key="view.view_name" @click="selectView(view)">
                                <td>{{ view.view_name }}</td>
                                <td>{{ usernameLookup(view.user_id) }}</td>
                                <td><v-icon>{{ getDeviceTypeIcon(view.view_device_type) }}</v-icon></td>

                                <td>
                                    <v-switch class="public-switch" color="#c42111" :ripple="true" :input-value="view.view_public" :disabled="view.user_id != $store.state.user.user_id" @click.native.capture.stop="publicClick(view)">
                                        <template v-slot:label>
                                            <label>
                                                {{ view.view_public ? 'public' : 'private' }}
                                            </label>
                                        </template>
                                    </v-switch>
                                </td>
                                <td>
                                    <v-btn icon @click.stop="favClick(view)">
                                        <v-icon la class="favorite-star" color="#ffffff" v-if="!view.fav">mdi-star-outline</v-icon>
                                        <v-icon class="favorite-star" color="yellow" v-if="view.fav">mdi-star</v-icon>
                                    </v-btn>
                                </td>
                                <td>
                                    <v-checkbox class="default-checkbox" color="#c42111" v-model="view.default" @click.stop="defaultClick(view)" />
                                </td>
                                <td>
                                    <v-btn icon color="#DC3545" :disabled="view.user_id != $store.state.user.user_id" @click.stop="deleteViewClick(view)"><v-icon la>mdi-delete-forever</v-icon></v-btn>
                                </td>
                            </tr>
                        </tr>
                    </tbody>
                </v-simple-table>

                <v-divider class="mt-4 mb-3" />

                <span class="selected-config-title">Selected View<span v-if="selectedView"> - </span><span style="color: yellow;" v-if="selectedView">{{selectedView.view_name}}</span></span>
                <v-btn class="ml-3" style="vertical-align: baseline;" color="#c42111" height="25" @click="applyView" v-if="selectedView">Apply View</v-btn>
                
                <geo-map-selected-view-details :selectedView="selectedView" :selectedViewClone="selectedViewClone" :mapViews="mapViews" :googleMapStylesThumbnails="googleMapStylesThumbnails" :mapThemes="mapThemes" :geoColors="geoColors" @save="saveViewNameClick" />

            </v-col>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('close')">Close</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { GoogleMapStylesThumbnails } from "@/components/GeoMap/GoogleMapStyles";
import GeoMapSelectedViewDetails from "@/components/GeoMap/GeoMapSelectedViewDetails";
export default {
    name: 'GeoMapViewManagement',
    props: ['mapViews'],
    components: {
        GeoMapSelectedViewDetails
    },
    data: () => ({
        tab: 0,
        geoColors: {},
        mapThemes: [
            {text: 'Standard', value: 'standard'},
            {text: 'Silver', value: 'silver'},
            {text: 'Retro', value: 'retro'},
            {text: 'Dark', value: 'dark'},
            {text: 'Night', value: 'night'},
            {text: 'Aubergine', value: 'aubergine'},
        ],
        googleMapStylesThumbnails: GoogleMapStylesThumbnails,
        selectedView: null,
        selectedViewClone: null,
    }),

    computed: {

    },

    methods: {
        selectView: function(view) {
            this.selectedView = view;
            this.selectedViewClone = JSON.parse(JSON.stringify(view));
        },

        publicClick: function(view) {
            // Warn them if they are making a public view private.
            if(view.view_public) {
                this.$store.commit('showConfirmModal', {
                    title: 'Confirm Overwrite',
                    message: `Making this view private will prevent other users from continuing to use it. Are you sure you want to do this?`,
                    type: 'warning',
                    hideCancel: false,
                    confirmAction: () => {view.view_public = false; this.saveView(view, view.view_name);}
                });
            }
            else {
                view.view_public = true;
                this.saveView(view, view.view_name);
            }
        },

        favClick: function(view) {
            view.fav = !view.fav;
            view.default = view.fav ? view.default : false;
            this.saveViewsFavs();
        },

        defaultClick: function(view) {
            let newVal = view.default;
            this.$props.mapViews.forEach(v => {
                v.default = false;
            });
            view.default = newVal;
            view.fav = view.default ? true : view.fav;
            this.saveViewsFavs();
        },

        saveViewsFavs: function() {
            let viewsFavs = [];
            for(let view of this.$props.mapViews) {
                if(view.fav) {
                    viewsFavs.push({
                        user_id: view.user_id,
                        view_name: view.view_name,
                        default: view.default
                    });
                }
            }

            let route = `${TELSA.apiHost}views/favs`;
            return this.$http.post(route, {args: {view_type: 'geomap', views_favs: viewsFavs}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },

        saveViewNameClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Overwrite',
                message: `Renaming this view will prevent other users from continuing to use it. Are you sure you want to do this?`,
                type: 'warning',
                hideCancel: false,
                confirmAction: () => {this.saveView(this.selectedViewClone, this.selectedView.view_name); this.selectedView.view_name = this.selectedViewClone.view_name;}
            });
        },
        saveView: function(view, oldViewName) {
            TELSA.loading(true);
            let route = `${TELSA.apiHost}views/edit`;
            return this.$http.post(route, {args: {view: view, old_view_name: oldViewName}}).then(response => {
                let result = response.body;
                this.saveViewsFavs();
                TELSA.loading(false);
            });
        },

        deleteViewClick: function(view) {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Delete',
                message: `Deleting this view will prevent other users from continuing to use it. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteView(view)
            });
        },
        deleteView: function(view) {
            TELSA.loading(true);
            this.$props.mapViews.splice(this.$props.mapViews.indexOf(view), 1);
            let route = `${TELSA.apiHost}views/delete`;
            return this.$http.post(route, {args: {view: view}}).then(response => {
                let result = response.body;
                this.saveViewsFavs();
                // If the view we just deleted is the one we're looking at, then remove that too.
                if(view == this.selectedView) {
                    this.selectedView = null;
                    this.selectedViewClone = null;
                }
                this.$emit('delete', view);
                TELSA.loading(false);
            });
        },

        applyView: function() {
            this.$emit('open', this.selectedView);
        },

        usernameLookup: function(userId) {
            for(let user of this.$store.state.batchConfig.users) {
                if(user.user_id == userId) {
                    return user.user_username;
                }
            }
            return '';
        },

        getDeviceTypeIcon: function(deviceType) {
            if(deviceType == 'smartphone') {
                return 'mdi-cellphone';
            }
            else if(deviceType == 'tablet') {
                return 'mdi-tablet-ipad';
            }
            else {
                return 'mdi-monitor';
            }
        },

    },

    created() {
        this.geoColors = this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical;
    },

    mounted() {

    }

  
};
</script>

<style scoped>

    .tab-content-full-height {
        /* height: calc(80vh - 50px); */
        /* height: 100%; */
        height: calc(75vh - 50px);
        overflow-y: auto;
    }

    .view-filter-card {
        /* border: rgba(255, 255, 255, 0.24) solid 1px !important; */
        /* border: black solid 1px !important; */
        height: 100%;
    }

    .config-table {
        border-radius: 3px;
        /* border: pink solid 1px; */
        border: rgba(255, 255, 255, 0.24) solid 1px;
        overflow-y: auto;
        background-color: #303030 !important;
    }
    .config-table thead tr th {
        background-color: #303030 !important;
    }

    .default-checkbox {
        margin: 0px !important;
        padding: 0px !important;
        height: 25px;
    }




    .config-table-label {
        display: block;
        color: #ffffff;
        font-size: 18px;
        margin-bottom: 0.5em;
    }

    .public-switch {
        margin: 0px !important;
        padding: 0px !important;
        height: 25px;
    }

    .favorite-star {
        cursor: pointer;
    }

    .default-checkbox {
        margin: 0px !important;
        padding: 0px !important;
        height: 25px;
    }

    .config-tables-container {
        margin-top: 1em;
    }

    .selected-config-title {
        display: inline-block;
        color: #ffffff;
        font-size: 18px;
    }

</style>
